// Replacement of _.get
// https://gist.github.com/harish2704/d0ee530e6ee75bad6fd30c98e5ad9dab
// work well for both object and array in path
// https://gist.github.com/todgru/37b11b51bc2a1ba4cf316dfd2d51d1a4
const getProp = (obj, path, defaultValue = undefined) => {
  const travel = (regexp) =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce(
        (res, key) => (res !== null && res !== undefined ? res[key] : res),
        obj
      );
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === undefined || result === obj ? defaultValue : result;
};

export function get(o, key, defaultV) {
  const result = getProp(o, key, defaultV);
  return result != null ? result : defaultV;
}

export function getValue(o, defaultValue = '', path = '') {
  if (path) {
    const paths = path.split('.');
    return o[paths.concat('value')] || o[paths] || defaultValue;
  } else if (!o) {
    return defaultValue;
  } else {
    return (
      (o.value !== undefined ? o.value : Object.keys(o).length ? o : null) ||
      defaultValue
    );
  }
}

export function getLabel(o, defaultValue = '', path = '') {
  if (path) {
    const paths = path.split('.');
    return o[paths.concat('label')] || o[paths] || defaultValue;
  } else {
    return (o && o.label !== undefined ? o.label : o) || defaultValue;
  }
}
